import React from 'react'
import pt from 'prop-types'
import { Field } from 'formik'
import SwitchButton from '@/components/controls/SwitchButton'

const SwitchButtonField = ({ label, ...ownProps }) => (
  <Field {...ownProps}>
    {({ field, form }) => {
      const { isSubmitting } = form

      const onChange = (value) => {
        form.setFieldValue(field.name, value)
      }

      return (
        <SwitchButton
          {...ownProps}
          {...field}
          onChange={onChange}
          label={label}
          disabled={isSubmitting || ownProps.disabled}
        />
      )
    }}
  </Field>
)

SwitchButtonField.defaultProps = {
  label: null,
}

SwitchButtonField.propTypes = {
  label: pt.oneOfType([pt.string, pt.element]),
}

export default React.memo(SwitchButtonField)
